import React from 'react';
import { CustomIcon } from '../../../components/UI';
import '../../loads-page/components/ActiveFilters.scss';

const ActiveFilters = ({ filters, onRemoveFilter, onClearAll }) => {
  if (filters.length === 0) return null;

  return (
    <div className="active-filters">
      <div className="filters-container">
        <div className="filters-list">
          {filters.map((filter, index) => (
            <div key={index} className="filter-tag">
               <button
                type="button"
                className="remove-filter-btn"
                onClick={() => onRemoveFilter(index)}
                title="Remove filter"
              >
                <CustomIcon name="close" size={14} />
              </button>
              <span className="filter-label">{filter}</span>
            </div>
          ))}
        </div>
        
        <button 
          type="button"
          className="clear-all-btn"
          onClick={onClearAll}
        >
          Clear All
        </button>
      </div>
    </div>
  );
};

export default ActiveFilters;

